<template>
    <v-card tile
            flat
            class="pa-2 mb-2">
        <v-overlay v-if="!item.product.active" color="black" opacity="0.7" absolute>
            <div class="d-flex flex-column align-center justify-center">
                <div class="mb-1">
                    {{ $vuetify.lang.t('$vuetify.widgets.cart.product_unavailable') }}
                </div>
                <v-icon v-ripple @click="removeItem">mdi-close</v-icon>
            </div>
        </v-overlay>

        <div class="d-flex">
            <div>
                <v-avatar size="115"
                          tile
                          class="mr-4">
                    <v-img :src="productImageSrc(item.product)">
                        <card-image-overlay v-if="item.product.unavailable || !item.product.active || !item.product.available_in_country"
                                            :unavailable="item.product.unavailable"
                                            :inactive="!item.product.active"
                                            :availableInCountry="item.product.available_in_country"/>
                    </v-img>
                </v-avatar>
            </div>

            <div class="d-flex flex-column" style="width: 100%;">
                <v-row no-gutters>
                    <v-col>
                        <div class="body-1 text-uppercase">{{ item.product.product_brand }}</div>
                        <div class="body-1 font-weight-bold">{{ item.product.title }}</div>
                    </v-col>
                    <v-col cols="auto">
                        <v-icon v-ripple @click="removeItem">mdi-close</v-icon>
                    </v-col>
                </v-row>


                <!--<div>{{ Number(item.quantity) | number }}x</div>-->

                <v-row no-gutters align="center">
                    <v-col cols="auto" class="mr-3">
                        {{ $vuetify.lang.t('$vuetify.widgets.cart.quantity') }}:
                    </v-col>
                    <v-col cols="3">
                        <v-text-field filled
                                      dense
                                      hide-details
                                      type="number"
                                      :disabled="!item.product.active"
                                      :value="item.quantity"
                                      class="input--text-center"
                                      @change="updateItem"></v-text-field>
                    </v-col>
                    <v-col cols="auto" class="ml-auto">
                        {{ item.product.price * item.quantity | number }}{{ $vuetify.lang.t('$vuetify.points.short') }}
                    </v-col>
                </v-row>

            </div>
        </div>
    </v-card>
</template>
<script>
    // Models
    import Cart from '../../models/Cart';
    import CardImageOverlay from '../CardImageOverlay';

    export default {
        name: 'cart-item-card',
        components: {
            CardImageOverlay,
        },
        props: {
            item: {},
        },
        methods: {
            productImageSrc(product) {
                return product.images.length > 0 ? product.images[0].source : '//via.placeholder.com/150x150/a1a1a1/FF0000/?text=Fallback';
            },
            async removeItem() {
                await Cart.remove(this.item.product_id, this.item.quantity);
            },
            async updateItem(quantity) {
                if (Number(quantity) <= 0) {
                    await this.removeItem();
                } else {
                    await Cart.change(this.item.product_id, Number(quantity));
                }
            },
        },
    }
</script>
